import { goodsReceivedNote as goodsReceivedNoteEn } from '../en/goodsReceivedNote';

export const goodsReceivedNote = {
  ...goodsReceivedNoteEn,
  goodsReceivedNotes: 'பெறப்பட்ட பொருட்கள் குறிப்புகள்',
  allGoodsReceivedNotes: 'அனைத்து பெறப்பட்ட பொருட்கள் குறிப்புகள்',
  createGoodsReceivedNote: 'பெறப்பட்ட பொருட்கள் குறிப்பை உருவாக்கவும்',
  goodsReceivedNoteDetails: 'பெறப்பட்ட பொருட்கள் குறிப்பு விவரங்கள்',
  status_received: 'பெறப்பட்டது',
  status_cancelled: 'ரத்து செய்யப்பட்டது',
  viewAndManageAllGoodsReceivedNotes: "அனைத்து பெறப்பட்ட பொருட்கள் குறிப்புகளையும் பார்த்து நிர்வகிக்கவும்",
  createGoodsReceivedNoteDescription: "கொள்முதல் ஆர்டருக்கு எதிராக பெறப்பட்ட பொருட்களைப் பதிவு செய்யவும்",
  grnNumber: "GRN எண்",
  purchaseOrderNumber: "கொள்முதல் ஆர்டர்",
  supplier: "சப்ளையர்",
  warehouse: "கிடங்கு",
  receivedAt: "பெறப்பட்ட தேதி",
  receivedBy: "பெற்றவர்",
  createdAt: "உருவாக்கப்பட்ட தேதி",
  status: "நிலை",
  actions: "செயல்கள்",
  item: "பொருள்",
  details: "GRN விவரங்கள்",
  itemsToReceive: "பெற வேண்டிய பொருட்கள்",
  itemsReceived: "பெறப்பட்ட பொருட்கள்",
  orderedQty: "ஆர்டர் செய்த அளவு",
  remainingQty: "மீதமுள்ள அளவு",
  quantityReceived: "பெறப்பட்ட அளவு",
  unitsSelected: "அலகுகள் தேர்ந்தெடுக்கப்பட்டன",
  lookupPurchaseOrder: "கொள்முதல் ஆர்டரைத் தேடவும்",
  purchaseOrderIdPlaceholder: "கொள்முதல் ஆர்டரைத் தேர்ந்தெடுக்கவும்",
  lookupButton: "தேடு",
  warehouseLabel: "கிடங்கு",
  atLeastOneItemRequired: "பெறுவதற்கு குறைந்தது ஒரு பொருளைத் தேர்ந்தெடுக்கவும்",
  selectWarehouse: "கிடங்கைத் தேர்ந்தெடுக்கவும்",
  supplierDeliveryReference: "சப்ளையர் டெலிவரி குறிப்பு",
  supplierDeliveryReferencePlaceholder: "சப்ளையரின் விலைப்பட்டியல்/டெலிவரி சீட்டு எண் (விருப்பத்தேர்வு)",
  notes: "குறிப்புகள்",
  notesPlaceholder: "இந்தப் பெறுதல் பற்றிய குறிப்புகளைச் சேர்க்கவும்...",
  create: "பெறப்பட்ட பொருட்கள் குறிப்பை உருவாக்கவும்",
  save: "சேமி",
  cancelGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பை ரத்து செய்யவும்",
  print: "அச்சிடு",
  printGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பை அச்சிடவும்",
  backToGoodsReceivedNotes: "பெறப்பட்ட பொருட்கள் குறிப்புகளுக்குத் திரும்பு",
  confirmCancel: "இந்தப் பெறப்பட்ட பொருட்கள் குறிப்பை ரத்து செய்ய விரும்புகிறீர்களா? கையிருப்பும் கொள்முதல் ஆர்டரின் பெறப்பட்ட அளவும் திரும்பப் பெறப்படும்.",
  cancellationReason: "ரத்து செய்வதற்கான காரணம்",
  cancellationReasonPlaceholder: "ரத்து செய்வதற்கான காரணத்தை உள்ளிடவும்...",
  filterByWarehouse: "கிடங்கு மூலம் வடிகட்டு",
  filterByPurchaseOrder: "கொள்முதல் ஆர்டர் மூலம் வடிகட்டு",
  dateFrom: "இருந்து",
  dateTo: "வரை",
  allWarehouses: "அனைத்து கிடங்குகள்",
  goodsReceivedNoteCreatedSuccess: "பெறப்பட்ட பொருட்கள் குறிப்பு {number} வெற்றிகரமாக உருவாக்கப்பட்டது",
  goodsReceivedNoteCancelledSuccessfully: "பெறப்பட்ட பொருட்கள் குறிப்பு வெற்றிகரமாக ரத்து செய்யப்பட்டது",
  failedToCreateGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பை உருவாக்க முடியவில்லை",
  failedToLoadGoodsReceivedNotes: "பெறப்பட்ட பொருட்கள் குறிப்புகளை ஏற்ற முடியவில்லை",
  failedToLoadGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பை ஏற்ற முடியவில்லை",
  failedToCancelGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பை ரத்து செய்ய முடியவில்லை",
  someFieldsRequired: "சமர்ப்பிக்கும் முன் முன்னிலைப்படுத்தப்பட்ட புலங்களைச் சரிசெய்யவும்",
  purchaseOrderRequired: "கொள்முதல் ஆர்டரைத் தேர்ந்தெடுக்கவும்",
  warehouseRequired: "கிடங்கைத் தேர்ந்தெடுக்கவும்",
  purchaseOrderNotFound: "கொள்முதல் ஆர்டர் கிடைக்கவில்லை",
  purchaseOrderCancelled: "ரத்து செய்யப்பட்ட கொள்முதல் ஆர்டருக்கு எதிராக பொருட்களைப் பெற முடியாது",
  noGoodsReceivedNotesFound: "பெறப்பட்ட பொருட்கள் குறிப்புகள் எதுவும் இல்லை",
  noGoodsReceivedNotesYet: "இன்னும் பெறப்பட்ட பொருட்கள் குறிப்புகள் இல்லை.",
  noGoodsReceivedNotesFoundDescription: "உங்கள் தற்போதைய வடிப்பான்களுடன் பொருந்தும் குறிப்புகள் இல்லை",
  noGoodsReceivedNotesYetDescription: "சப்ளையரிடமிருந்து டெலிவரியைப் பதிவு செய்ய உங்கள் முதல் பெறப்பட்ட பொருட்கள் குறிப்பை உருவாக்கவும்.",
  createFirstGoodsReceivedNote: "முதல் பெறப்பட்ட பொருட்கள் குறிப்பை உருவாக்கவும்",
  na: "இல்லை",
  searchPurchaseOrder: "கொள்முதல் ஆர்டர் எண் அல்லது ID மூலம் தேடவும்...",
  noOpenPurchaseOrders: "திறந்த கொள்முதல் ஆர்டர்கள் எதுவும் இல்லை",
};
